/**
 * 故事圖片同時下載上限（不持久快取）。單元測試可 reset。
 */
const MAX_CONCURRENT = 2;

let active = 0;
const waiters = [];

function pump() {
  while (active < MAX_CONCURRENT && waiters.length > 0) {
    active += 1;
    const release = waiters.shift();
    release();
  }
}

/** @returns {Promise<() => void>} 取得後必須呼叫歸還 */
export function acquireStoryMediaSlot() {
  return new Promise((resolve) => {
    const grant = () => {
      let released = false;
      resolve(() => {
        if (released) return;
        released = true;
        active = Math.max(0, active - 1);
        pump();
      });
    };
    waiters.push(grant);
    pump();
  });
}

/** 測試用：清空佇列狀態。 */
export function resetStoryMediaDownloadGate() {
  active = 0;
  waiters.length = 0;
}

export function storyMediaDownloadGateStats() {
  return { active, waiting: waiters.length, max: MAX_CONCURRENT };
}
